import { render, staticRenderFns } from "./SanityDivider.vue?vue&type=template&id=54cfccce"
import script from "./SanityDivider.vue?vue&type=script&lang=js"
export * from "./SanityDivider.vue?vue&type=script&lang=js"
import style0 from "./SanityDivider.vue?vue&type=style&index=0&id=54cfccce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports